
import BaseDynamicComponent from "@/app/dynamic-components/forms/form-components/form-component.base";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AeAutocomplete from "@/components/common/Autocomplete.vue";
import { roleService } from "@/app/services/role.service";
import AutocompleteWithErrors from "@/app/components/AutocompleteWithErrors.vue";
import { DynamicFormEntry } from "@/app/dynamic-components/forms/dynamic-form.model";
import { dossierServiceV2 } from "@/app/services/dossier.service";
import {userServiceV2} from "@/app/services/user.service";
import UserInfo from "@/contracts/generic/UserInfo";
import {organisationService} from "@/app/services/organisation.service";
import {ruleEngine} from "@/app/services/rule.engine";
import {productService} from "@/app/services/product.service";
import {checkinService} from "@/app/services/checkin.service";
import {planningService} from "@/app/services/planning.service";
import {documentServiceV2} from "@/app/services/document.service";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";
import {partyService} from "@/app/services/party.service";

export type SelectOrgInRoleMetaData = {
  roleIdsOrganisation?: string[];
  roleIdsPerson?: string[];
  multipleUsers: boolean;
  translationKeyPerson: boolean;

  addUserAsParty: boolean
  addOrgAsParty: boolean
};

@Component({
  components: {DynamicComponentConfigManager, AutocompleteWithErrors, AeAutocomplete },
})
export default class FormComponentSelectOrgAndUserInRoles extends BaseDynamicComponent<SelectOrgInRoleMetaData> {
  orgs: string[] | string = [];
  eligibleOrganistions: { name: string; id: string }[] = [];
  loadingElegableOrganistions = false;

  currentFetchedElegablePersonsOrg = 'sqds';
  persons: string[] | string = [];
  eligiblePersons: { name: string; id: string }[] = [];
  loadingElegablePersons = false;
  currentlySelectedUser: UserInfo | null = null;

  preventOrgDetectiontrigger = false;

  getOrgErrors(){
    if(this.orgs?.length > 0){
      return this.errors.filter(value => value.id !== 'required');
    }
    return this.errors;
  }
  getOrgErrorMessages(){
    if(this.orgs?.length > 0){
      return [];
    }
    return this.errorMessages;
  }


  postEntityChanged(entry: DynamicFormEntry) {
    if (
      entry &&
      Array.isArray(entry?.metadata?.roleIdsOrganisation) &&
      Array.from(entry?.metadata?.roleIdsOrganisation).length > 0
    ) {
      roleService
        .getEligableOrganisations(Array.from(entry?.metadata?.roleIdsOrganisation)[0])
        .then((eligibleOrganistions) => {
          this.eligibleOrganistions = eligibleOrganistions;
        })
        .catch((reason) => {
          console.warn(
            "Failed to fetch EligableOrganisations for " +
              Array.from(entry?.metadata?.roleIdsOrganisation)[0] +
              " " +
              reason
          );
          this.eligibleOrganistions = [];
        });
    } else {
      this.eligibleOrganistions = [];
    }
  }

  get displayOrganisations(): string {
    return this.eligibleOrganistions
      .filter((eligibleOrg) => this.orgs.includes(eligibleOrg.id))
      .map((org) => org.name)
      .join(", ");
  }

  @Watch("orgs")
  onOrgsChanged() {
    const r = {
      org: this.orgs && Array.isArray(this.orgs) && this.orgs.length > 0 ? this.orgs[0] : (this.orgs as string || null),
      persons: []
    };

    if(!r.org){
      this.setValueView(null);
      this.currentFetchedElegablePersonsOrg = 'dsqsdqs'
      this.eligiblePersons = [];
    }
    if(r.org && r.org !== this.currentFetchedElegablePersonsOrg){
      this.currentFetchedElegablePersonsOrg = r.org;
      this.eligiblePersons = [];
      this.loadingElegablePersons = true;
      roleService
          .getEligibleUsersForRole(Array.from(this.entry?.metadata?.roleIdsPerson)[0] as string, false, Array.isArray(this.orgs) ? this.orgs[0] : this.orgs)
          .then((eligiblePersons) => {
            this.eligiblePersons = eligiblePersons.map((value) => {
              return { name: value.fullName, id: value.id };
            });
            this.loadingElegablePersons = false;
          })
          .catch((reason) => {
            console.warn(
                "Failed to fetch eligiblePersons for " +
                Array.from(this.entry?.metadata?.roleIdsPerson)[0] +
                " " +
                reason
            );
            this.eligiblePersons = [];
            this.loadingElegablePersons = false;
          });
    }

    if(this.preventOrgDetectiontrigger){
      this.preventOrgDetectiontrigger = false;
      return;
    }
    this.setValueView(r);
  }

  get displayPersons(): string {
    if (this.currentlySelectedUser)
      return (
          this.currentlySelectedUser.firstName +
          " " +
          this.currentlySelectedUser.lastName
      );
    return this.eligiblePersons
        .filter((person) => this.persons.includes(person.id))
        .map((person) => person.name)
        .join(", ");
  }

  @Watch("persons")
  onPersonsChanged() {
    const r = {
      org: this.orgs && Array.isArray(this.orgs) && this.orgs.length > 0 ? this.orgs[0] as string : (this.orgs || null),
      persons: this.persons
    };

    if(r.org === null || r.org === undefined || r.org === 'undefined' || r.org === ''){
      this.setValueView(null);
      return;
    }

    this.setValueView(r);
  }
  postSetValueView(value: any) {
    if(!value){
      this.orgs = [];
      this.persons = [];
      this.currentlySelectedUser = null;
      return;
    }

    if (value.org !== this.orgs) {
      if(value.persons !== this.persons){
        this.preventOrgDetectiontrigger = true;
      }
      this.orgs = value.org;
    }

    if (value.persons !== this.persons) {
      this.persons = value.persons;
      if (value.persons) {
        userServiceV2.getUsersByIds([value.persons]).then((value) => {
          this.currentlySelectedUser = value[0];
        });
      } else {
        this.currentlySelectedUser = null;
      }
    }

  }

  async afterSave(sumbitData: any): Promise<boolean> {
    if (!sumbitData?.type) return true;
    if (!sumbitData?.referenceId) return true;
    if (!this.entry?.value) return true;

    // sumbitData.type === "dossier" is legacy code, addAsParty should be enable on these in the future
    const addUserAsParty = await ruleEngine.resolveRuleAsync(this.getContext(), this.metadata?.addUserAsParty || false, this);
    const addORgAsParty = await ruleEngine.resolveRuleAsync(this.getContext(), this.metadata?.addOrgAsParty || false, this);
    if(sumbitData.type === "dossier" || addORgAsParty || addUserAsParty){
      const r = this.entry.value;
      let orgs = r.org;
      if(!Array.isArray(orgs)){
        orgs = [orgs];
      }
      let persons = r.persons;
      if(!Array.isArray(persons)){
        persons = [persons];
      }

      if(sumbitData.type === "dossier" || addORgAsParty ){
        for (let contactId of orgs) {
          await partyService.addOrg(sumbitData.type, sumbitData.referenceId, contactId as string, this.entry?.metadata?.roleIdsOrganisation? this.entry?.metadata?.roleIdsOrganisation[0] : undefined);
        }
      }

      if(sumbitData.type === "dossier" || addUserAsParty ){
        for (let contactId of persons) {
          await partyService.addUser(sumbitData.type, sumbitData.referenceId, contactId as string, this.entry?.metadata?.roleIdsPerson? this.entry?.metadata?.roleIdsPerson[0] : undefined);
        }
      }

    }
    return true;
  }

  public async fillIndexerValue(indexerField: string, indexerSelector): Promise<any> {
    if('users' === indexerSelector){
      if(this.persons && Array.isArray(this.persons)){
        let filteredPersons = this.eligiblePersons.filter((person) => this.persons.includes(person.id));
        if(filteredPersons.length < this.persons.length){
          //this can happen with computed values, as elegable onlu checks first roleid
          const fetchedPersons = await  userServiceV2.getUsersByIds(this.persons);
          filteredPersons = fetchedPersons.map(person => {
            return {
              name: person.fullName,
              id: person.id
            }
          });
        }
        return filteredPersons
            .map((person) => person.name)
            .join(", ") || "";
      }else if(typeof this.persons === 'string'){
        let filteredPersons = this.eligiblePersons.filter((person) => person.id === this.persons);
        if(filteredPersons.length < 1){
          //this can happen with computed values, as elegable onlu checks first roleid
          const fetchedPersons = await userServiceV2.getUsersByIds([this.persons]);
          filteredPersons = fetchedPersons.map(person => {
            return {
              name: person.fullName,
              id: person.id
            }
          });
        }
        return filteredPersons
            .map((person) => person.name)
            .join(", ") || "";
      }
    }

    if('orgs' === indexerSelector){
      if(this.orgs && Array.isArray(this.orgs)){
        let filteredOrgs = this.eligibleOrganistions.filter((org) => this.orgs.includes(org.id));
        if(filteredOrgs.length < this.orgs.length){
          //this can happen with computed values, as elegable onlu checks first roleid
          const fetchedOrgs = await organisationService.getOrganisationsByIds(this.orgs);
          filteredOrgs = fetchedOrgs.map(value => {
            return {
              name: value.name,
              id: value.id
            }
          });
        }
        return filteredOrgs
            .map((org) => org.name)
            .join(", ") || "";
      }else if(typeof this.orgs === 'string'){
        let filteredOrgs = this.eligibleOrganistions.filter((org) => org.id === this.orgs);
        if(filteredOrgs.length < 1){
          //this can happen with computed values, as elegable onlu checks first roleid
          const fetchedOrgs = await organisationService.getOrganisationsByIds([this.orgs]);
          filteredOrgs = fetchedOrgs.map(value => {
            return {
              name: value.name,
              id: value.id
            }
          });
        }
        return filteredOrgs
            .map((org) => org.name)
            .join(", ") || "";
      }
    }

    return super.fillIndexerValue(indexerField, indexerSelector);
  }
}
